module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "content-heading"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success btn-noborder float-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openManualRefundModal
    }
  }, [_c('i', {
    staticClass: "fa fa-plus mr-5"
  }), _vm._v("Nieuwe Retour\n    ")]), _vm._v(" "), _c('i', {
    staticClass: "si si-basket mr-5"
  }), _vm._v(" Retours\n  ")]), _vm._v(" "), (_vm.ManualDetailModalShow) ? _c('manual-refund-modal', {
    on: {
      "close": function($event) {
        _vm.ManualDetailModalShow = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('api-table-block', {
    ref: "ordersTable",
    attrs: {
      "fields": _vm.fields,
      "items": _vm.findAllRefunds,
      "default-sort-by": "created_at",
      "item-label-singular": "bestelling",
      "item-label-plural": "bestellingen"
    },
    scopedSlots: _vm._u([{
      key: "check",
      fn: function(data) {
        return [_c('label', {
          key: data.item.order.number,
          staticClass: "css-control css-control-primary css-checkbox"
        }, [_c('input', {
          staticClass: "css-control-input",
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": _vm.selectedOrders.includes(data.item.order.number)
          },
          on: {
            "change": function($event) {
              _vm.selectOrder(data.item.order.number, $event)
            }
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "css-control-indicator"
        })])]
      }
    }, {
      key: "number",
      fn: function(data) {
        return [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.openDetailModal(data.item.order.id, data.item.id)
            }
          }
        }, [_vm._v("#" + _vm._s(data.item.order_number))])]
      }
    }, {
      key: "billing_person",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(data.item.order.billing_person) + " "), (data.item.order.billing_company) ? _c('small', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s(data.item.order.billing_company))]) : _vm._e()]
      }
    }, {
      key: "placed_at",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(_vm._f("capitalize")(_vm._f("moment")(data.item.order.placed_at, 'calendar'))) + "\n    ")]
      }
    }, {
      key: "status",
      fn: function(data) {
        return [_c('refund-status-badge', {
          attrs: {
            "refund": data.item
          }
        })]
      }
    }, {
      key: "actions",
      fn: function(data) {
        return [_c('button', {
          staticClass: "btn btn-sm btn-secondary",
          on: {
            "click": function($event) {
              _vm.openDetailModal(data.item.order.id, data.item.id)
            }
          }
        }, [_vm._v("Details")])]
      }
    }])
  }, [_c('template', {
    slot: "before-block-content"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('label', {
    staticClass: "css-control css-control-sm css-control-primary css-switch "
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showOnlyProcessing),
      expression: "showOnlyProcessing"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showOnlyProcessing) ? _vm._i(_vm.showOnlyProcessing, null) > -1 : (_vm.showOnlyProcessing)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.showOnlyProcessing,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showOnlyProcessing = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showOnlyProcessing = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showOnlyProcessing = $$c
        }
      }, _vm.refresh]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" Alleen openstaand\n          ")]), _vm._v(" "), _c('label', {
    staticClass: "css-control css-control-sm css-control-primary css-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showOnlyDropship),
      expression: "showOnlyDropship"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showOnlyDropship) ? _vm._i(_vm.showOnlyDropship, null) > -1 : (_vm.showOnlyDropship)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.showOnlyDropship,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showOnlyDropship = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showOnlyDropship = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showOnlyDropship = $$c
        }
      }, _vm.refresh]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" Alleen dropshipments\n          ")])])])])], 2), _vm._v(" "), _c('barcode-scanner', {
    on: {
      "scan": _vm.openDetailModal
    }
  }), _vm._v(" "), (_vm.detailModalOrderId) ? _c('refund-detail-modal', {
    key: _vm.detailModalOrderId,
    attrs: {
      "order-id": _vm.detailModalOrderId,
      "refundId": _vm.detailModalRefundId,
      "includeRefundShipmentCosts": true
    },
    on: {
      "close": function($event) {
        _vm.detailModalOrderId = null, _vm.refresh()
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7103643c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/refunds/RefundsPage.vue
// module id = 734
// module chunks = 1